module.exports = __webpack_public_path__ + "static/media/dungeon_floor_s.ac6188a7.png";